module.exports = __webpack_public_path__ + "static/media/silicon-valley.858c3f76.jpg";